import { tv } from 'tailwind-variants';

export const timelineVariants = tv({
  slots: {
    wrapper: [
      'relative',
      'w-full',
      'mx-auto',
      'after:content-[""] after:absolute after:top-0 after after:bottom-0',
      'after:left-0 xm:after:left-[50px] md:after:left-1/2 md:after:-translate-x-1/2',
      'after:bg-light-gray',
      'after:w-0.5',
      'xm:px-[50px] md:px-0',
    ],
    dropdownWrapper: ['relative', 'md:mx-auto', 'mb-24', 'w-full max-w-[250px]', 'z-10'],
    dropdown: [
      'w-full',
      'px-3',
      'py-1.5',
      'border',
      'bg-white',
      'rounded',
      'text-base',
      'text-textPrimary',
      'font-medium',
      'cursor-pointer',
      'appearance-none',
      'pr-10',
      'focus:outline-none',
      'focus:ring-2',
      'focus:ring-accent-light-blue',
    ],
    dropdownIcon: [
      'fa-regular fa-chevron-down',
      'absolute right-2 top-1/2 -translate-y-1/2',
      'text-xs',
    ],
    timelineContainer: ['relative'],
    timelineItem: [
      'grid',
      'grid-cols-1',
      'md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]',
      'pb-12',
      'items-start',
    ],
    imageWrapper: [
      'flex',
      'justify-center',
      'md:justify-end',
      'items-start',
      'px-[15px] md:px-12',
      'md:pr-8',
    ],
    image: [
      'w-full h-auto',
      'mb-2',
      'object-cover',
      'border-[10px] border-white',
      'shadow-[-3px_2px_13px_0_rgba(00,_00,_00,_.4)] md:shadow-[-5px_2px_13px_0_rgba(00,_00,_00,_.4)]',
    ],
    contentWrapper: ['flex', 'flex-col', 'px-[15px] md:px-12'],
    horizontalLine: ['relative', 'h-[1px]', 'bg-secondary', '-mx-[14px] md:-mx-12 mt-1'],
    horizontalLineDot: [
      'absolute',
      'left-0',
      'top-1/2',
      '-translate-y-1/2',
      '-translate-x-1/2',
      'w-2.5',
      'h-2.5',
      'bg-secondary',
      'rounded-full',
      'z-10',
    ],
    title: ['text-[30px] font-black leading-[45.6px] text-light-black'],
    description: ['pt-4.5', 'text-textPrimary', 'text-lg', 'font-light', 'leading-[27px]'],
    backToTopLinkWrapper: ['md:col-span-2', 'inline-flex mx-auto', 'z-10', 'py-1'],
    backToTopLink: [
      'bg-white',
      'mt-12',
      'text-sm leading-[21px] text-secondary font-black',
      'cursor-pointer',
    ],
  },
});
